import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { ErrorBoundary, PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { mfeLazyLoadErrorHandler } from '../../utils/mfe';

const VehicleMaintenance = React.lazy(() => importRemote<any>({
  url: getMfeUrl('VEHICLE_MAINTENANCE'),
  scope: 'VehicleMaintenance',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadErrorHandler));

export default function VehicleMaintenanceWrapper({ navbarLoaded }: { navbarLoaded: boolean }) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <ErrorBoundary>
        <VehicleMaintenance />
      </ErrorBoundary>
    </Suspense>
  );
}
